import React from "react";
import { useLocation } from "react-router-dom";
import { CheckoutRoutes } from "../typings/enums";
import AppUrlListener from "./AppUrlListener/AppUrlListener";
import { AppRoutes } from "../constants/routesConstants";

// Wrapper component that conditionally renders AppUrlListener based on route
const ConditionalAppUrlListener: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();

  const pathWithoutQuery = location.pathname.split("?")[0];

  // Define patterns for routes that should not be wrapped with AppUrlListener
  const excludedPathPatterns = [
    // Checkout routes
    ...Object.values(CheckoutRoutes),
    // Appointment routes
    AppRoutes.CREATE_APPOINTMENT,
    AppRoutes.CREATE_APPOINTMENT_SCHEDULE,
    AppRoutes.CREATE_APPOINTMENT_ORDER_COMPLETE,
    "/telemedicine-agreement",
  ];

  // Check if current path matches any excluded route pattern
  const shouldExcludeRoute = excludedPathPatterns.some(
    (pattern) =>
      pathWithoutQuery === pattern || pathWithoutQuery.startsWith(pattern)
  );

  // Don't wrap with AppUrlListener on excluded routes
  if (shouldExcludeRoute) {
    console.log(
      `AppUrlListener disabled for excluded route: ${location.pathname}`
    );
    return <>{children}</>;
  }

  // Wrap with AppUrlListener for all other routes
  console.log(`AppUrlListener enabled for route: ${location.pathname}`);
  return <AppUrlListener>{children}</AppUrlListener>;
};

export default ConditionalAppUrlListener;
